import React, {Component, ReactElement} from 'react'
import NatStepComponent, {DIspStepInfo, Step} from '../common/resident/NatStepComponent'
import NatTokenRepo from '../token/repository/NatTokenRepo'
import NatRoomToResidentRepo from '../roomToResident/repository/NatRoomToResidentRepo'
import NatResidentUserRepo, {
    CreateAuthorizeRequest,
    SetSeverSessionInfoRequest,
} from '../residentUser/repository/NatResidentUserRepo'
import {NatGetToken} from '../token/repository/NatGetToken'
import {VALID_OR_NOT} from '../../../CodeMaster'
import {getQueryParameter, NatAsyncCallFunction, setSessionStorage} from '../../common/util/Natutil'
import styled from 'styled-components'
import {
    ContentsSubTitleInner,
    ContentsSubTitleWrapper,
    ParagraphText,
    WideMainContainer,
} from '../../../styledComponents/ContentsArea'
import {StyledDiv} from '../../../styledComponents/StyledTypeDefinitions'
import {TitleErrorLabel,} from '../../../styledComponents/DisplayItem'
import {PrimaryStyledButton} from '../../../styledComponents/Button'
import {Messages} from '../../../Messages'
import {Nullable} from '../../../app/TypeHelpers'
import {ErrorResponseBody} from '../../../network/response/ErrorResponseBody'
import {BaseHttpError} from '../../../network/errors/baseHandling/BaseHttpError'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {BlockSpacer} from '../../../styledComponents/ResponsiveConvenience'
import {OpenInNew} from '@mui/icons-material'
import {NatGetRoomToResidentAuthenticationKey} from '../roomToResident/repository/NatGetRoomToResidentAuthenticationKey'
import {HKConstants} from '../../../HKConstants'
import {Location} from 'react-router-dom'
import {NatSetServerSessionInfo} from '../residentUser/repository/NatSetServerSessionInfo';
import {NatCreateGenerateRequestParam} from '../residentUser/repository/NatCreateGenerateRequestParam';
import {NatCreateAuthorizeUrl} from '../residentUser/repository/NatCreateAuthorizeUrl';
import {SessionStorageHelper} from '../../../SessionStorageHelper';

interface FirstLoginLocationState {
    firstLoginLocationState: {
        dIspStepInfo: DIspStepInfo
    }
}

interface Props {
    tokenRepo: NatTokenRepo,
    residentUserRepo: NatResidentUserRepo,
    roomToResidentRepo: NatRoomToResidentRepo,
    location: Location
}

interface States {
    token: NatGetToken,
    condominiumData: NatGetRoomToResidentAuthenticationKey,
    hasekoIdLoginButtonFlg: boolean,
    password: string,
    dispPassword: string,
    errorTitleMessage: string,
    isLoadCompleted: boolean,
}

const FIRSTLOGINLOCATIONSTATE = 'firstLoginLocationState'
const QUERYTOKEN = 'queryToken'
const KEY_LOGIN_ID: string = 'loginId'
const KEY_SENI_URL = 'seniUrl'
const SUTEKINETOF_NOTICE = 'sutekiNetOfNotice';
const TOKEN = 'token';
const CONDOMINIUM_DATA = 'condominiumData';
const WISHTOHASEKOGROUPINFOS = 'wishToHasekoGroupInfos'
const ISOWNERSHIPTRANSFER = 'isOwnershipTransfer'
const DISPSTEPINFO = 'dIspStepInfo'

class NatResidentFirstLoginHasekoIdPasswordConfirmPage extends Component<Props & ResidentPagePropsSet, States> {
    queryToken: string
    isOwnershipTransfer: boolean
    dIspStepInfo: DIspStepInfo

    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
        this.state = {
            token: {
                details: {
                    token: '',
                    sutekiNetId: '',
                    mailAddress: '',
                    authenticationKey: '',
                    parentResidentId: '',
                    policyAgreeType: '',
                    referenceId: '',
                    condominiumCd: '',
                    condominiumName: '',
                    ridgeCd: '',
                    ridgeName: '',
                    roomNumber: '',
                    familyName: '',
                    firstName: '',
                    familyNameKana: '',
                    firstNameKana: '',
                    freeSettingItem: '',
                    flpExistFlag: '',
                },
                informations: null,
                requestError: null,
                requestItemErrors: null,
            },
            condominiumData: {
                details: {
                    condominiumCd: '',
                    condominiumName: '',
                    ridgeCd: '',
                    ridgeName: '',
                    roomNumber: '',
                    parentResidentId: '',
                    receivingAgencyCd: '',
                },
                informations: null,
                requestError: null,
                requestItemErrors: null,
            },
            hasekoIdLoginButtonFlg: true,
            password: '',
            dispPassword: VALID_OR_NOT.NOT.value,
            errorTitleMessage: '',
            isLoadCompleted: false,
        }
        this.queryToken = getQueryParameter('token', this.props.location.search)
        this.isOwnershipTransfer = new URLSearchParams(this.props.location.search).has('ownershipTransfer')
        this.dIspStepInfo = this.props.location.state?.firstLoginLocationState?.dIspStepInfo ??
            {
                hasekoIdPasswordConfirm: true,
                userConfirm: true,
                complete: true,
            }

        this.systemErrorTransition = this.systemErrorTransition.bind(this)
        this.handleInputChange = this.handleInputChange.bind(this)
        this.handlePassworDispTypeChange = this.handlePassworDispTypeChange.bind(this)
        this.hasekoIdLoginButtonClick = this.hasekoIdLoginButtonClick.bind(this)
    }

    async componentDidMount(): Promise<void> {
        const systemErrorMessageId =
            this.isOwnershipTransfer ? Messages.ERESR0013.toString() : Messages.ERESR0003.toString()

        if (this.queryToken === '') {
            this.props.navigate('/resident/error', {
                state: {
                    message: systemErrorMessageId,
                    nonDisplayBackBtnFlag: this.isOwnershipTransfer,
                },
            })
            return
        }

        await this.props.eventEmitter.showLoading()
        try {
            // トークンチェック
            const retToken: Nullable<NatGetToken> = await NatAsyncCallFunction(
                this.props.tokenRepo.getToken.bind(
                    this.props.tokenRepo, this.queryToken), this.props.navigate, this.systemErrorTransition)
            if (retToken && retToken.details === null) {
                this.props.navigate('/resident/error', {
                    state: {
                        message: systemErrorMessageId,
                        nonDisplayBackBtnFlag: this.isOwnershipTransfer,
                    },
                })
                return
            } else if (retToken && retToken.details) {
                // 物件情報取得
                const condominiumData: Nullable<NatGetRoomToResidentAuthenticationKey> = await NatAsyncCallFunction(
                    this.props.roomToResidentRepo.getRoomToResidentByAuthenticationKey.bind(
                        this.props.roomToResidentRepo, retToken.details.authenticationKey),
                    this.props.navigate,
                    this.systemErrorTransition,
                )
                if (condominiumData) {
                    this.setState({
                        token: retToken,
                        condominiumData: condominiumData,
                    })
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }

    }

    // システムエラー遷移
    systemErrorTransition(): void {
        this.props.navigate(`/resident/error`, {
            state: {
                message: Messages.ESYCC0018.toString(),
                nonDisplayBackBtnFlag: this.isOwnershipTransfer,
            },
        })
    }

    // 入力
    handleInputChange(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            password: event.target.value,
            hasekoIdLoginButtonFlg: event.target.value === '',
        })
    }

    // パスワードを表示する
    handlePassworDispTypeChange(event: React.ChangeEvent<HTMLInputElement>): void {
        if (event.target.checked) {
            this.setState({dispPassword: VALID_OR_NOT.VALID.value})
        } else {
            this.setState({dispPassword: VALID_OR_NOT.NOT.value})
        }
    }

    // 登録する
    async hasekoIdLoginButtonClick(): Promise<void> {
        const isSutekiNetSmartPhoneApplication = SessionStorageHelper
            .getStringItemWithDefault('isSutekiNetSmartPhoneApplication', 'false');

        if (isSutekiNetSmartPhoneApplication === 'true') {
            const setSeverSessionInfoRequestSp: SetSeverSessionInfoRequest = {
                authenticationKey: null,
                ssoLoginCondominiumCd: null,
                ssoLoginRidgeCd: null,
                ssoLoginRoomNumber: null,
                loginPage: null,
                token: null,
                isSutekiNetSmartPhoneApplication: isSutekiNetSmartPhoneApplication
            };
            const ret: Nullable<NatSetServerSessionInfo> =
                await NatAsyncCallFunction(this.props.residentUserRepo.setBackendSessionInfo.bind(
                        this.props.residentUserRepo, setSeverSessionInfoRequestSp),
                    this.props.navigate
                );
        }

        if (this.state.token.details === null ||
            this.state.condominiumData.details === null) {
            return
        }

        await this.props.eventEmitter.showLoading()
        try {
            const querytoken = this.queryToken
            const token = this.state.token
            const condominiumData = this.state.condominiumData
            const isOwnershipTransfer = this.isOwnershipTransfer
            const dIspStepInfo = this.dIspStepInfo
            setSessionStorage(QUERYTOKEN, querytoken)
            setSessionStorage(TOKEN, JSON.stringify(token))
            setSessionStorage(CONDOMINIUM_DATA, JSON.stringify(condominiumData))
            setSessionStorage(ISOWNERSHIPTRANSFER, isOwnershipTransfer)
            setSessionStorage(DISPSTEPINFO, JSON.stringify(dIspStepInfo))
            const setSeverSessionInfoRequest: SetSeverSessionInfoRequest = {
                authenticationKey: (this.state.token.details.authenticationKey) ?
                    this.state.token.details.authenticationKey : '',
                ssoLoginCondominiumCd: '',
                ssoLoginRidgeCd: '',
                ssoLoginRoomNumber: '',
                loginPage: 'NatResidentFirstLoginHasekoIdPasswordConfirmPage',
                token: querytoken,
                isSutekiNetSmartPhoneApplication: null
            };

            const ret: Nullable<NatSetServerSessionInfo> =
                await NatAsyncCallFunction(this.props.residentUserRepo.setBackendSessionInfo.bind(
                        this.props.residentUserRepo, setSeverSessionInfoRequest),
                    this.props.navigate
                );
            if (ret) {
                // ログイン認証
                // ステート、ノンス取得し、セッションへ格納
                const createGenerateRequestParam: Nullable<NatCreateGenerateRequestParam> =
                    await NatAsyncCallFunction(
                        this.props.residentUserRepo.createGenerateRequestParam.bind(
                            this.props.residentUserRepo), this.props.navigate);
                const mailAddressForParam = this.state.token.details.mailAddress
                if (createGenerateRequestParam) {
                    // パラメータ作成
                    const createAuthorizeRequest: CreateAuthorizeRequest = {
                        mailAddress: encodeURIComponent(mailAddressForParam),
                    };
                    const natCreateAuthorizeUrl: Nullable<NatCreateAuthorizeUrl> =
                        await NatAsyncCallFunction(
                            this.props.residentUserRepo.createAuthorize.bind(
                                this.props.residentUserRepo, createAuthorizeRequest), this.props.navigate);
                    if (natCreateAuthorizeUrl && natCreateAuthorizeUrl.details) {
                        const seniurl: string = getQueryParameter('seniurl', this.props.location.search);
                        if (seniurl) {
                            setSessionStorage(KEY_SENI_URL, seniurl);
                        }
                        window.location.href = natCreateAuthorizeUrl.details;
                    }
                }
            }
        } catch (HttpError) {
            const errorResponseBody: Nullable<ErrorResponseBody> = (HttpError as BaseHttpError).responseBody
            if (errorResponseBody !== null) {
                if (errorResponseBody.requestError !== null) {
                    this.setTitleErrorMessage(errorResponseBody.requestError.title)
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    // メッセージ設定(タイトル)
    setTitleErrorMessage(message: string): void {
        this.setState({errorTitleMessage: message})
    }

    // メッセージ取得（タイトル）
    getTitleErrorMessage(): Nullable<ReactElement> {
        if (this.state.errorTitleMessage !== '') {
            return (
                <TitleErrorLabel>
                    {this.state.errorTitleMessage}
                </TitleErrorLabel>
            )
        } else {
            return null
        }
    }

    onClickForgotPassword(): void {
        window.open(HKConstants.CMN.OPC.FLP_FORGET_PASSWORD_MAIL_URL, '_blank')
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        return (
            <>
                <NatStepComponent
                    dIspStepInfo={this.dIspStepInfo}
                    nowStep={Step.HASEKO_ID_PASSWORD_CONFIRM}
                />
                <ContentsSubTitleWrapper>
                    <ContentsSubTitleInner>
                        パスワードの確認
                    </ContentsSubTitleInner>
                </ContentsSubTitleWrapper>
                <MessageBlock>
                    <Message>
                        ご登録いただいたメールアドレスは、既に長谷工IDおよび素敵ネットに登録されています。<br/>
                        パスワードを入力してログインしてください。
                    </Message>
                </MessageBlock>
                {this.getTitleErrorMessage()}
                <WideMainContainer>
                </WideMainContainer>
                <BlockSpacer height={'30px'}/>
                <PrimaryStyledButton
                    id={'loginPassBtn'}
                    onClick={this.hasekoIdLoginButtonClick}>
                    ログインする
                </PrimaryStyledButton>
                <BlockSpacer height={'30px'}/>
            </>
        )
    }
}

export default createResidentPage(NatResidentFirstLoginHasekoIdPasswordConfirmPage)

// メッセージブロック
const MessageBlock: StyledDiv = styled.div`
    text-align: center;
`
// メッセージ
const Message = styled(ParagraphText)`
    display: inline-block;
    text-align: left;
`
// アイコン
const StyledExternalUrlIcon = styled(OpenInNew)`
    margin-left: 5px;
    vertical-align: sub;
    width: 18px !important;
    height: 18px !important;
`
